import {
    IHomeState,
    IHomeStaticInformation,
    initialHomeStaticInformationState,
    normalizeHomeStaticInformation
} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {getHomeContent} from "./ActionCreators";

const initialValue: IHomeState = {
    loading: false,
    content: initialHomeStaticInformationState
}

const homeSlice = createSlice({
    name: SliceNames.HOME,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getHomeContent.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getHomeContent.fulfilled, (state, action: PayloadAction<IHomeStaticInformation>) => {
                    state.content = normalizeHomeStaticInformation(action.payload)
                    state.loading = false
                })
            .addCase(
                getHomeContent.rejected, (state) => {
                    state.loading = false
                })
    }
})

export default homeSlice.reducer
